module.exports = __webpack_public_path__ + "static/texture-wood-f15dcdbe50e67e8c1b640ab6f6eaf643.jpg";